import { useTrackToggle } from '@livekit/components-react';
import * as React from 'react';
import { getSourceIcon } from '../../lib/getSourceIcon';

export function TrackToggle({ showIcon, ...props }) {
	const { buttonProps, enabled } = useTrackToggle(props);
	return (
		<button {...buttonProps}>
			{(showIcon ?? true) && getSourceIcon(props.source, enabled)}
			{props.children}
		</button>
	);
}
